import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/RootState'

import { initialState } from './slice'

const selectDomain = (state: RootState) => state.common || initialState

export const selectCommon = createSelector([selectDomain], Common => Common)
